import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';
import { useMemo } from 'react';
import { createTitle } from 'utils/meta';

import styles from './VitalsMock.module.scss';

const measurements = ['40-Time', 'Arm Length', 'Hands'];

interface VitalsMockProps {
  className?: string;
}
export const VitalsMock = ({ className }: VitalsMockProps) => {
  const { athlete } = useAthlete();

  const sportOrg = useMemo(() => {
    if (athlete.defaultSport?.key === 1) return 'NFL Combine';
    if (athlete.defaultSport?.key === 2) return 'NBA Combine';

    return null;
  }, [athlete.defaultSport]);

  const highSchool =
    athlete.highSchool?.knownAs ??
    athlete.highSchoolName ??
    athlete.highSchool?.fullName;

  return (
    <section className={clsx(styles.section, className)}>
      <figure className={styles.block}>
        <figcaption id="vitals-legend">
          <ul>
            <li>
              <strong>{athlete.name}</strong>
              <Link href={`/high-school/${athlete.highSchool?.urlSlug}/`}>
                {highSchool}
              </Link>
            </li>
            <li>
              <strong>Top 300 {athlete.positionAbbreviation} Avg</strong>
              <span>Avg. Last 5 Years</span>
            </li>
            <li>
              <strong>{createTitle(sportOrg, 'Drafted')}</strong>
              <span>Avg. Last 5 Years</span>
            </li>
          </ul>
        </figcaption>
        <div className={styles.measurements}>
          {measurements.map((measurement, index) => (
            <div className={styles.graph} key={index}>
              <div className={styles.label}>{measurement}</div>
              <div className={styles.barGraph}>
                <div />
                <div />
                <div />
              </div>
            </div>
          ))}
        </div>
      </figure>
      <Link
        className={styles.edit}
        forceReload
        href={`/rivals/${athlete.slug}/claim-profile/`}
      >
        <Pen />
        Add Vitals to see how you stack up
      </Link>
    </section>
  );
};
